<script>
	import { styles } from '../scripts/styles.js'
	let seconds = '0' + 0
	let minutes = '0' + 0
	let hours = '0' + 0

	export let fontLarge = '18px'
	export let fontSmall = '12px'
	export let titleColor = 'black'
	export let timerColor = 'green'
	export let name = 'time elapsed'

	const set_time = () => {
		seconds++
		if (seconds < 10) seconds = '0' + seconds
		if (seconds === 60) {
			minutes++
			if (minutes < 10) minutes = '0' + minutes
			seconds = '0' + 0
			if (minutes === 60) {
				hours++
				if (hours < 10) hours = '0' + hours
				minutes = '0' + 0
			}
		}

		const toAnimation = setTimeout(() => {
			window.requestAnimationFrame(set_time)
		}, 1000)
	}
	window.requestAnimationFrame(set_time)
</script>

<div class="container">
	<div class="title" use:styles={{ fontSmall, titleColor }}>{name}</div>
	<div class="timer" use:styles={{ fontLarge, timerColor }}>{hours + ' : ' + minutes + ' : ' + seconds}</div>
</div>

<style>
	.container {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
	}
	.title {
		font-size: var(--fontSmall);
		color: var(--titleColor);
		margin-bottom: 10px;
	}
	.timer {
		font-size: var(--fontLarge);
		color: var(--timerColor);
	}
</style>
